import { FormTextField } from '@orbis-systems/orbis-react-toolkit';
import { ErrorMessage } from 'formik';
import React from 'react';

import { Visibility, VisibilityOff } from '@mui/icons-material';
import { ButtonBase, Grid, IconButton, InputAdornment, Typography } from '@mui/material';

import Form from '@components/forms';
import SubmitButton from '@components/submitButton';

import useResetPasswordForm from './hooks';
import { ResetPasswordFormProps } from './interfaces';

function ResetPasswordForm({ initialValues, onSubmit, sentTime }: ResetPasswordFormProps) {
	const {
		showPassword,
		showPasswordConfirmation,
		handleShowPassword,
		handleShowPasswordConfirmation,
		handleResendCode,
		minutes,
		seconds,
		formik,
	} = useResetPasswordForm({
		initialValues,
		onSubmit,
		sentTime,
	});

	return (
		<Form formik={formik}>
			<Grid container rowSpacing={3} mt={0}>
				<Grid item xs={12}>
					<FormTextField
						name={'password'}
						label={'Password'}
						type={showPassword ? 'text' : 'password'}
						autoComplete="off"
						InputProps={{
							endAdornment: (
								<InputAdornment position="end">
									<IconButton aria-label="Toggle password visibility" onClick={handleShowPassword}>
										{showPassword ? <VisibilityOff /> : <Visibility />}
									</IconButton>
								</InputAdornment>
							),
						}}
						disabled={formik.isSubmitting}
					/>
				</Grid>

				<Grid item xs={12}>
					<FormTextField
						name={'password_confirmation'}
						label={'Password confirmation'}
						type={showPasswordConfirmation ? 'text' : 'password'}
						autoComplete="off"
						InputProps={{
							endAdornment: (
								<InputAdornment position="end">
									<IconButton aria-label="Toggle password visibility" onClick={handleShowPasswordConfirmation}>
										{showPasswordConfirmation ? <VisibilityOff /> : <Visibility />}
									</IconButton>
								</InputAdornment>
							),
						}}
						disabled={formik.isSubmitting}
					/>
				</Grid>

				<Grid item xs={12}>
					<FormTextField name={'code'} label={'Verification code'} autoComplete="off" disabled={formik.isSubmitting} />
				</Grid>

				<Grid item display={'flex'} justifyContent={'space-between'} xs={12} style={{ paddingTop: '10px' }}>
					<Typography variant={'body2'}>
						<b>{seconds || minutes ? 'Code expires in:' : 'Code has been expired'}</b>{' '}
						<b>
							{minutes || seconds
								? `${minutes > 9 ? minutes : `0${minutes}`}:${seconds > 9 ? seconds : `0${seconds}`}`
								: ''}
						</b>
					</Typography>

					<ButtonBase onClick={handleResendCode}>
						<Typography variant="body2">
							<b>Resend code?</b>
						</Typography>
					</ButtonBase>
				</Grid>

				<Grid item xs={12}>
					<SubmitButton label={'Submit'} disabled={!formik.dirty || formik.isSubmitting} />
				</Grid>

				<Grid
					item
					xs={12}
					sx={{
						color: theme => theme.palette.error.main,
						textAlign: 'center',
					}}
				>
					<ErrorMessage name="resetPasswordError" />
				</Grid>
			</Grid>
		</Form>
	);
}

export default ResetPasswordForm;
